import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="data-source-fields"
export default class extends Controller {
  static values = { url: String }

  reload(event) {
    const query = { data_source_id: event.target.value }
    // Carry the columns already chosen, so the redrawn fields keep the ones the new source has.
    for (const attribute of ["timestamp_column_name", "currency_column_name", "value_override_fields_csv"]) {
      const field = event.target.form?.elements.namedItem(`conversion_event[${attribute}]`)
      if (field?.value) query[`conversion_event[${attribute}]`] = field.value
    }
    get(this.urlValue, { query, responseKind: "turbo-stream" })
  }
}
